export const isAiSetting = (key) =>
  typeof key === 'string' && key.trim().toLowerCase().startsWith('ai:');

export const isAiAllowedUsersSetting = (key) =>
  typeof key === 'string' && key.trim().toLowerCase() === 'ai:allowedusers';

export const isDoclingApiKeySetting = (key) =>
  typeof key === 'string' && key.trim().toLowerCase() === 'ai:doclingapikey';

export const filterSettingsForTab = (settings, activeTab) =>
  (settings || []).filter((setting) =>
    activeTab === 'ai' ? isAiSetting(setting.key) : !isAiSetting(setting.key),
  );
